import { useMutation } from '@tanstack/react-query';
import {
  UpdateBankOperationsCommentParams,
  updateBankOperationComment,
} from 'config/requests/bankOperations';

export function useUpdateBankOperationsComment() {
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateBankOperationsCommentParams }) =>
      updateBankOperationComment(id, data),
  });
}
